import React, { Suspense } from 'react';
import { useAuth } from 'auth/context/AuthContext';
import { useModalParams } from 'components/modal/useModalManager';
import NavbarMobile from 'components/navbar/navbarMobileComponent';
import DownloadReport from 'app/my-skin/components/downloadReport';
import { BaseLayout } from 'layout/BaseLayout';
import { useVerifyChild } from 'app/my-account/pages/child/useVerifyChild';
import ChildQuestionnaireBanner from 'app/my-account/pages/child/ChildQuestionnaireBanner';
import { UnverifiedChildMobileNavbar } from 'components/navbar/UnverifiedChildNavbar';
import { Outlet } from 'react-router-dom';
import { PatientNavbar } from './PatientNavbar';
import { FallbackLoader } from 'components/loaderComponent';
import { PatientProfileProvider } from '../../app/my-account/pages/patient/PatientProfileContext';
import { ProviderConnectContextProvider } from './ConectProviderContext';

export const PatientLayout: React.FC = () => {
  const { selectedAccount } = useAuth();
  const { isVerify } = useVerifyChild();
  const { isOpen: isDownloadReportWarningOpen } =
    useModalParams('download-warning');

  return (
    <PatientProfileProvider>
      <ProviderConnectContextProvider>
        <BaseLayout
          extraModals={isDownloadReportWarningOpen ? <DownloadReport /> : null}
          banner={selectedAccount ? <ChildQuestionnaireBanner /> : null}
          renderNavbar={({ openNavbarMobile }) => (
            <PatientNavbar openNavbarMobile={openNavbarMobile} />
          )}
          renderMobileNavbar={({ closeNavbarMobile }) => {
            if (!isVerify && selectedAccount) {
              return (
                <UnverifiedChildMobileNavbar
                  closeNavbarMobile={closeNavbarMobile}
                />
              );
            }
            return <NavbarMobile closeNavbarMobile={closeNavbarMobile} />;
          }}
        >
          <Suspense fallback={<FallbackLoader />}>
            <Outlet />
          </Suspense>
        </BaseLayout>
      </ProviderConnectContextProvider>
    </PatientProfileProvider>
  );
};

export default PatientLayout;
